var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
var buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-disabled", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow hover:bg-primary-hover",
            destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary-hover",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
            // Enhanced status variants
            success: "bg-success text-success-foreground shadow hover:bg-success-hover",
            warning: "bg-warning text-warning-foreground shadow hover:bg-warning-hover",
            error: "bg-error text-error-foreground shadow hover:bg-error-hover",
            info: "bg-info text-info-foreground shadow hover:bg-info-hover",
            // Muted variants for subtle actions
            "success-muted": "bg-success-muted text-success border border-success/20 hover:bg-success/10",
            "warning-muted": "bg-warning-muted text-warning border border-warning/20 hover:bg-warning/10",
            "error-muted": "bg-error-muted text-error border border-error/20 hover:bg-error/10",
            "info-muted": "bg-info-muted text-info border border-info/20 hover:bg-info/10",
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
var Button = React.forwardRef(function (_a, ref) {
    var className = _a.className, variant = _a.variant, size = _a.size, _b = _a.asChild, asChild = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? "button" : _c, props = __rest(_a, ["className", "variant", "size", "asChild", "type"]);
    return (_jsx("button", __assign({ type: type, className: cn(buttonVariants({ variant: variant, size: size, className: className })), ref: ref }, props)));
});
Button.displayName = "Button";
export { Button, buttonVariants };
